export function extractUsernameFromSocialMediaLink(link) {
  // Define a regular expression map for known social media platforms
  var regexMap = {
    linkedin: /linkedin\.com\/(?:in|company)\/([A-Za-z0-9_-]+)/,
    facebook: /facebook\.com\/([A-Za-z0-9_.-]+)/,
    tiktok: /tiktok\.com\/(@?[A-Za-z0-9_.-]+)/,
    youtube: /youtube\.com\/(@?[A-Za-z0-9_.-]+)/,
    instagram: /instagram\.com\/([A-Za-z0-9_.-]+)/,
    twitter: /twitter\.com\/(@?[A-Za-z0-9_.-]+)/
  };
  var platform = Object.keys(regexMap).find(function (key) {
    var regex = regexMap[key];
    var match = link.match(regex);
    return match && match[1];
  });

  // If a match is found, return the username; otherwise, return ""
  return platform ? link.match(regexMap[platform])[1].replace('@', '') : '';
}